module.exports = __webpack_public_path__ + "static/media/login_ul_icon.eb1f4028.png";